<template>
  <ul class="bottom-remarks">
    <li v-for="i in lang === 'zh' ? 8 : 10" :key="i" class="bottom-remarks-item">
      {{ $t(`bottom-remarks-item-${i}`) }}
    </li>
  </ul>
</template>
<script>
export default {
  inject: ['lang']
};
</script>
<style lang="scss">
.bottom-remarks {
  margin: auto;
  max-width: 1200px;
  width: 83.3vw;
  padding-top: 68px;
  padding-bottom: 150px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 13px;
  line-height: 200%;
  color: rgba(0, 0, 0, 0.4);
  text-align: left;
}
@media screen and (max-width: 734px) {
  html[lang|='zh'] {
    .bottom-remarks {
      line-height: 26px;
    }
  }
  .bottom-remarks {
    border: none;
    padding: 40px 20px 40px;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    font-size: 12px;
    line-height: 22px;
    color: rgba(133, 133, 133, 0.5);
  }
}
</style>
